import { z } from 'zod';
import { SkillLevel, StaffLevel } from './admin-users.js';
import { OrgRole } from './auth.js';
/**
 * Một kỹ năng trên thẻ sơ đồ — tên tech stack và mức tự khai.
 *
 * Chỉ tên và mức, không kèm số năm: thẻ rộng 14rem, và câu hỏi người xem sơ đồ
 * đặt ra là "ai biết React", không phải "ai biết React lâu nhất".
 */
export const OrgChartSkill = z.object({ name: z.string(), level: SkillLevel });
/**
 * ⚠️ Kiểu khai tay, schema `z.lazy`, **không** dùng getter đệ quy của Zod.
 *
 * `get children() { return z.array(OrgChartNode) }` chạy đúng lúc validate
 * nhưng TypeScript suy `children` thành `Record<string, unknown>[]` — nên phía
 * dùng mất sạch kiểu của node con, và lỗi chỉ lộ ra ở chỗ render đệ quy chứ
 * không ở chỗ khai.
 */
export const OrgChartNode = z.lazy(() => z.object({
    userId: z.uuid(),
    displayName: z.string(),
    email: z.string(),
    orgRole: OrgRole,
    isOrgAdmin: z.boolean(),
    level: StaffLevel.nullable(),
    departmentName: z.string().nullable(),
    isActive: z.boolean(),
    lineManagerId: z.uuid().nullable(),
    reportCount: z.number().int().nonnegative(),
    skills: z.array(OrgChartSkill),
    children: z.array(OrgChartNode),
}));
export const OrgChartView = z.object({
    /**
     * Người không có quản lý trực tiếp **trong phạm vi nhìn thấy được**.
     *
     * Người mà quản lý của họ đã nghỉ việc (hoặc nằm ngoài mốc `asOf`) nổi lên
     * thành gốc. Họ phải hiện ra: bỏ sót người không gắn được vào cây nghĩa là
     * sơ đồ đếm thiếu người mà không có gì nói ra.
     */
    roots: z.array(OrgChartNode),
    /** Tổng số người trong phạm vi — để đối chiếu với tổng đếm được trên cây. */
    total: z.number().int().nonnegative(),
    /**
     * Có ai bị bỏ khỏi cây vì quan hệ quản lý tạo thành vòng lặp không.
     *
     * `line_manager_id` chỉ bị chặn mỗi trường hợp tự trỏ vào mình, nên A→B→A là
     * dữ liệu **hợp lệ với schema** và dựng cây đệ quy trên nó sẽ treo trình
     * duyệt. Ta cắt vòng và nói ra, thay vì im lặng làm mất người.
     */
    cycleCount: z.number().int().nonnegative(),
});
//# sourceMappingURL=org-chart.js.map